export const DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
};
